import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import TokenExpired from "./components/TokenExpired";
import style from "./App.module.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import NotFound from "./pages/NotFound";
import Quote from "./pages/Quote";
import ProductList from "./pages/ProductList";
import Product from "./pages/Product";
import CategoryList from "./pages/CategoryList";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UniflowCalculator from "./pages/UniflowCalculator";
import MdsCalculator from "./pages/MdsCalculator";
import EntryPoint from "./pages/EntryPoint";
import ErrorBoundary from "./components/ErrorBoundary";
import BrowserWarning from "./components/BrowserWarning";

export default function App() {
  return (
    <ErrorBoundary>
      <Router>
        <BrowserWarning />
        <div className={style.root}>
          <Header />

          <div>
            <Switch>
              <Route path="/" exact component={CategoryList} />
              <Route path="/quote" exact component={Quote} />
              <Route path="/category/:id" component={ProductList} />
              <Route path="/product/:sku" component={Product} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/terms-and-conditions" component={TermsConditions} />
              <Route path="/uniflow-calculator" component={UniflowCalculator} />
              <Route path="/mds-calculator" component={MdsCalculator} />
              <Route
                path="/cpq/index/quote/oid/:oid/returnurl/:returnUrl"
                component={EntryPoint}
              />
              <Route
                path="/cpq/index/quote/oid/:oid/qid/:qid/returnurl/:returnUrl"
                component={EntryPoint}
              />
              <Route component={NotFound} />
            </Switch>
          </div>

          <Footer />
          <Loader />
          <TokenExpired />
        </div>
      </Router>
    </ErrorBoundary>
  );
}
